import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { State } from '../../../typings/state';
import { TDispatchProps, TStateProps } from '../../../typings/utils';
import { CanvasAction } from '../../common/actions';
import { Page } from '../../common/typings';
import {
    cancelPreviewsModal,
    changeSize,
    checkSize,
    closePreviewsModal,
    createGraphicCreative,
    crop,
    cropModalClose,
    initCommonCreative,
    optionChange,
    returnSelect,
    saveName,
    showPreviewsModal,
    submitPreviewsModal,
    toggleOptionGroupVisibility,
    togglePreview
} from '../actions';
import { selectCommonCreativeState } from '../selectors';

import { AddCommonCreative, AddCommonCreativeProps } from './AddCommonCreative';
import { selectPcodeData } from './selectors';

type StateProps = TStateProps<AddCommonCreativeProps>;
type DispatchProps = TDispatchProps<AddCommonCreativeProps, OwnProps>;
type OwnProps = {
    onCancel: () => void;
};

const mapStateToProps = (state: State): StateProps => {
    const addCreativeState = selectCommonCreativeState(state.canvasEditor.canvas.addCreative);
    const ideaId = state.canvasEditor.canvas.commonData.ideaId;
    const {
        isLoading,
        isSaving,
        creativeOptions,
        error,
        previewsModalVisible,
        editingFileInfo,
        currentId,
        items,
        previewItems,
        ideaFilesCropped,
        createPressed,
        returnPage
    } = addCreativeState;

    return {
        isLoading,
        isSaving,
        creativeOptions,
        returnPage,
        error,
        previewsModalVisible,
        afterCrop: Boolean(editingFileInfo),
        currentId,
        items,
        previewItems,
        pcodeData: selectPcodeData(addCreativeState),
        createPressed: Boolean(ideaId && !ideaFilesCropped && createPressed)
    };
};

const mapDispatchToProps = (dispatch: Dispatch<CanvasAction>): DispatchProps => {
    return {
        onOptionChange: (groupName: string, name: string, value: string): void => {
            dispatch(optionChange(groupName, name, value));
        },
        onGroupVisibleChange: (groupName: string): void => {
            dispatch(toggleOptionGroupVisibility(groupName));
        },
        onSaveName: (name: string): void => {
            dispatch(saveName(name));
        },
        onSave: (): void => {
            dispatch(createGraphicCreative());
        },
        crop: (id: number): void => {
            dispatch(crop(id));
        },
        showPreviewsModal: (): void => {
            dispatch(showPreviewsModal(true));
        },
        cancelPreviewsModal: (): void => {
            dispatch(cancelPreviewsModal());
        },
        cropModalClose: (): void => {
            dispatch(cropModalClose());
        },
        closePreviewsModal: (): void => {
            dispatch(closePreviewsModal());
        },
        submitPreviewsModal: (continueEdit?: boolean): void => {
            dispatch(submitPreviewsModal(continueEdit));
        },
        togglePreview: (ids: number[], val: boolean): void => {
            dispatch(togglePreview(ids, val));
        },
        changeSize: (value: number): void => {
            dispatch(changeSize(value));
        },
        checkSize: (value: number): void => {
            dispatch(checkSize(value));
        },
        initCommonData: (): void => {
            dispatch(initCommonCreative());
        },
        onReturnClick: (page?: Page): void => {
            dispatch(returnSelect(page));
        }
    };
};

export const AddCommonCreativeContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(AddCommonCreative);
